import { Button, Select, Input, Tooltip } from "antd";
import {
  FilterIcon,
  SearchIcon,
  SelectArrow,
  TickIcon,
} from "../../../../atoms/CustomIcons";
import React, { useState } from "react";
import { useAppSelector } from "../../../../config/hooks";

interface FilterProps {
  setFilters: React.Dispatch<
    React.SetStateAction<{
      type: undefined | string;
      status: undefined | string[];
      state: undefined;
      city: undefined;
      onboarding_complete_date: string[] | undefined;
      last_user_activity: string[] | undefined;
      search_text: undefined | string;
    }>
  >;
  filters: {
    type: undefined | string;
    status: undefined | string[];
    state: undefined;
    city: undefined;
    onboarding_complete_date: string[] | undefined;
    last_user_activity: string[] | undefined;
    search_text: undefined | string;
  };
  archived: boolean;
  isArchived: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function Filters(props: FilterProps) {
  const { setFilters, filters, archived, isArchived } = props;
  const [showFilters, setShowFilters] = useState(false);

  const clientManagerList = useAppSelector(
    (state) => state?.company?.companyClientManager
  );

  const clearFilters = () => {
    setFilters({
      type: undefined,
      status: undefined,
      state: undefined,
      city: undefined,
      onboarding_complete_date: undefined,
      last_user_activity: undefined,
      search_text: undefined,
    });
    isArchived(false);
  };

  return (
    <div className="filtersWrapper">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h3>Select template </h3>
        <div className="filtersTop">
          <div className="filterSearch">
            <Input
              prefix={<SearchIcon />}
              placeholder="Search"
              value={filters?.search_text}
              allowClear
              onChange={(e) =>
                setFilters((prev) => ({
                  ...prev,
                  search_text: e.target.value,
                }))
              }
            />
          </div>
          <div className="filterToggle">
            <Button
              icon={<FilterIcon />}
              className={`outlined-btn ${showFilters && "show_filters"} ${
                archived && "archived"
              }`}
              onClick={() => setShowFilters(!showFilters)}
            >
              Filters{" "}
              <div className="filter_icon">
                <SelectArrow />
              </div>
            </Button>
          </div>
        </div>
      </div>
      {showFilters && (
        <div className="filtersBottom">
          <div className="btmLeft">
            <div className="filterBox">
              <Tooltip title="Property category" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  onChange={(value) =>
                    setFilters((prev) => ({ ...prev, type: value }))
                  }
                  value={filters?.type}
                  placeholder="Property category"
                  options={[
                    {
                      value: "Option 1",
                      label: "Option 1",
                    },
                    {
                      value: "Option 2",
                      label: "Option 3",
                    },
                  ]}
                />
              </Tooltip>
            </div>

            <div className="filterBox">
              <Tooltip title="Service line" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Service line"
                  options={clientManagerList}
                  mode="multiple"
                  maxTagCount={1}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Renewable" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Renewable"
                  options={clientManagerList}
                  mode="multiple"
                  maxTagCount={1}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Pricing model" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Pricing model"
                  options={clientManagerList}
                  mode="multiple"
                  maxTagCount={1}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Billing" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Billing"
                  options={clientManagerList}
                  mode="multiple"
                  maxTagCount={1}
                />
              </Tooltip>
            </div>
            <Button
              className="outlined-btn"
              onClick={clearFilters}
              disabled={!filters.type && !filters.status}
            >
              Clear filters
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
